module.exports = __webpack_public_path__ + "media/flags/mg-9c179afa.svg";